import { actionFactory, typeFactory } from 'common/store/scope';

export const LOAD = 'LOAD';
export const LOAD_SUCCESS = 'LOAD_SUCCESS';
export const LOAD_ERROR = 'LOAD_ERROR';
export const UPDATE = 'UPDATE';
export const CLEAR = 'CLEAR';

export const load = ({ clear = true } = {}) => ({
  type: LOAD,
  clear,
});

export const loadSuccess = (resource, uiondemandpersistreadingsystemdefault) => {
  return {
    type: LOAD_SUCCESS,
    resource,
    uiondemandpersistreadingsystemdefault: uiondemandpersistreadingsystemdefault
  };
}

export const loadError = error => ({
  type: LOAD_ERROR,
  error,
});

export const update = resource => ({
  type: UPDATE,
  resource,
});

export const clear = () => ({
  type: CLEAR,
});

export const factory = namespace => ({
  ...actionFactory(namespace, {
    load,
    loadSuccess,
    loadError,
    update,
    clear,
  }),
  TYPES: typeFactory(namespace, {
    LOAD,
    LOAD_SUCCESS,
    LOAD_ERROR,
    UPDATE,
    CLEAR,
  }),
});

export default factory;
